import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';

export interface ElectronDisplayMediaSourceOption {
  id: string;
  name: string;
  thumbnail_data_url: string | null;
}

export interface ElectronDisplayMediaPickerDialogData {
  sources: ElectronDisplayMediaSourceOption[];
  supports_system_audio: boolean;
}

export interface ElectronDisplayMediaPickerDialogResult {
  source_id: string;
  include_system_audio: boolean;
}

@Component({
  selector: 'app-electron-display-media-picker-dialog',
  templateUrl: './electron-display-media-picker-dialog.component.html',
  styleUrls: ['./electron-display-media-picker-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatRadioModule, MatCheckboxModule, FormsModule],
})
export class ElectronDisplayMediaPickerDialogComponent {
  private dialog_ref = inject(MatDialogRef<ElectronDisplayMediaPickerDialogComponent>);
  protected data = inject<ElectronDisplayMediaPickerDialogData>(MAT_DIALOG_DATA);

  protected selected_source_id = this.data.sources[0]?.id ?? '';
  protected include_system_audio = this.data.supports_system_audio;

  confirm(): void {
    if (this.selected_source_id === '') {
      return;
    }

    this.dialog_ref.close({
      source_id: this.selected_source_id,
      include_system_audio: this.data.supports_system_audio && this.include_system_audio,
    } satisfies ElectronDisplayMediaPickerDialogResult);
  }

  cancel(): void {
    this.dialog_ref.close();
  }
}
